import { createSlice } from '@reduxjs/toolkit';
var registerReducers = require('@cdo/apps/redux').registerReducers;
var initialState = {
    isPlaying: false
};
var musicSlice = createSlice({
    name: 'music',
    initialState: initialState,
    reducers: {
        setIsPlaying: function (state, action) {
            state.isPlaying = action.payload;
        }
    }
});
// TODO: If/when a top-level component is created that wraps {@link MusicView}, then
// registering reducers should happen there. We are registering reducers here for now
// because MusicView is currently the top-level entrypoint into Music Lab and also needs
// to be connected to this state.
registerReducers({ music: musicSlice.reducer });
export var setIsPlaying = musicSlice.actions.setIsPlaying;
